import { Tooltip } from "@mui/material";
import classNames from "classnames";

import { SidebarContainer, SidebarIconContainer, SidebarPanel } from "./containers";
import { SidebarIcon } from "./icons";
import { useSidebar } from "./SidebarContext";
import type { SidebarResource } from "./types";

type Props = {
  resources: SidebarResource[];
  hidden?: boolean;
};

export const Sidebar = ({ resources, hidden }: Props) => {
  const { main, popOut, selectMainPanelByName } = useSidebar();

  const selectedResource = resources.find((r) => r.name === main.selectedResourceName);

  const popOutPanel = popOut.getPanel(resources);

  return (
    <SidebarContainer data-test="sidebar-container" style={hidden ? { display: "none" } : undefined}>
      <SidebarIconContainer data-test="sidebar-icons-container">
        {resources
          .filter(({ iconName, icon }) => !!icon || !!iconName)
          .map(({ name, iconName, icon, iconTooltip, disabled }) => (
            <Tooltip key={name} title={iconTooltip ?? ""} placement="right">
              <SidebarIcon
                disabled={disabled}
                key={name}
                icon={iconName}
                onClick={() => selectMainPanelByName(name)}
                className={classNames({ isActive: main.isOpen && selectedResource?.name === name })}
                data-test={`sidebar-icon-${name}-button`}
              >
                {icon}
              </SidebarIcon>
            </Tooltip>
          ))}
      </SidebarIconContainer>

      <SidebarPanel expanded={main.isOpen} type="main" data-test="sidebar-main-panel">
        {selectedResource?.panel}
      </SidebarPanel>

      <SidebarPanel expanded={!!popOutPanel && popOut.isOpen} type="popOut" data-test="sidebar-pop-out-panel">
        {popOutPanel}
      </SidebarPanel>
    </SidebarContainer>
  );
};
